module.exports = __webpack_public_path__ + "static/media/add.644d8b05.svg";